export default [
    {
        name: "ItemGroupCreate",
        path: "item-group",
        component: () => import('./../../views/warehouse/ItemGroupCreateView.vue')
    },
    {
        name: "ItemGroupDisplay",
        path: "item-group/:id",
        component: () => import('./../../views/warehouse/ItemGroupDisplayView.vue')
    },
    {
        name: "ItemGroupList",
        path: "item-groups",
        component: () => import('./../../views/warehouse/ItemGroupListView.vue')
    },
    {
        name: "ItemGroupEdit",
        path: "item-groups/:id/edit",
        component: () => import('./../../views/warehouse/ItemGroupEditView.vue')
    }
]